<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Collection Target vs Realization 
                <div class="card-header-actions">
                    <button class="btn btn-primary mr-1" @click="exportxls()">
                        <i class="fa fa-file-excel-o"></i>
                        Export
                    </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="5">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Periode Date</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" readonly></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="2">
                    <b-button class="btn btn-success" @click="process()" > <i class="fa fa-play"></i> Open</b-button>
                </b-col>

            </b-row >
            <b-card no-body>
                <b-input-group >
                    <b-input-group-prepend><label> &nbsp;&nbsp;&nbsp;Hide Column   :</label></b-input-group-prepend>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="JanShow" class="mt-1 mr-2" size="sm">Jan</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="FebShow" class="mt-1 mr-2" size="sm">Feb</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="MarShow" class="mt-1 mr-2" size="sm">Mar</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="AprShow" class="mt-1 mr-2" size="sm">Apr</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="MeiShow" class="mt-1 mr-2" size="sm">Mei</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="JunShow" class="mt-1 mr-2" size="sm">Jun</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="JulShow" class="mt-1 mr-2" size="sm">Jul</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="AgtShow" class="mt-1 mr-2" size="sm">Agt</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="SepShow" class="mt-1 mr-2" size="sm">Sep</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="OktShow" class="mt-1 mr-2" size="sm">Oct</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="NovShow" class="mt-1 mr-2" size="sm">Nov</b-form-checkbox>
                    <b-form-checkbox :value="false" :unchecked-value="true" v-model="DesShow" class="mt-1 mr-2" size="sm">Dec</b-form-checkbox>
                </b-input-group>
                <div class="report-wraper">
                    <table >
                        <thead>
                            <tr>
                                <th width="250px" rowspan="2">Description</th>
                                <th colspan="3" style="text-align:center;" v-if="JanShow">Jan {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="FebShow">Feb {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="MarShow">Mar {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="AprShow">Apr {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="MeiShow">Mei {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="JunShow">Jun {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="JulShow">Jul {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="AgtShow">Aug {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="SepShow">Sep {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="OktShow">Okt {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="NovShow">Nov {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="DesShow">Des {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;">Year To Date</th>
                                <th colspan="3" style="text-align:center;">TOTAL</th>
                            </tr>
                            <tr>
                                <th style="text-align:center" width="100px" v-if="JanShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="JanShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="JanShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="FebShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="FebShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="FebShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="MarShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="MarShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="MarShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="AprShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="AprShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="AprShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="MeiShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="MeiShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="MeiShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="JunShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="JunShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="JunShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="JulShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="JulShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="JulShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="AgtShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="AgtShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="AgtShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="SepShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="SepShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="SepShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="OktShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="OktShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="OktShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="NovShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="NovShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="NovShow">Variant </th>
                                <th style="text-align:center" width="100px" v-if="DesShow">Budget</th>
                                <th style="text-align:center" width="100px" v-if="DesShow">Actual</th>
                                <th style="text-align:center" width="100px" v-if="DesShow">Variant </th>
                                <th style="text-align:center" width="100px">Budget</th>
                                <th style="text-align:center" width="100px">Actual</th>
                                <th style="text-align:center" width="100px">Variant </th>
                                <th style="text-align:center" width="100px">Budget</th>
                                <th style="text-align:center" width="100px">Actual</th>
                                <th style="text-align:center" width="100px">Variant </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptLines" :key="row.collector_id">
                                <td :class="row.kelas"><div style="width: 250px; overflow: hidden; display: inline-block; white-space: nowrap;">
                                    {{row.collector_name}}</div></td>
                                <td :class="row.kelas"  v-if="JanShow" style="text-align:right">
                                    {{row.budget1 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="JanShow" style="text-align:right">
                                    {{row.actual1| numFormat}}                              
                                </td>
                                <td :class="row.kelas"  v-if="JanShow" style="text-align:right">
                                    {{row.varian1 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="FebShow" style="text-align:right">
                                    {{row.budget2 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="FebShow" style="text-align:right">
                                    {{row.actual2| numFormat}}                                
                                </td>
                                <td :class="row.kelas"  v-if="FebShow" style="text-align:right">
                                    {{row.varian2 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="MarShow" style="text-align:right">
                                    {{row.budget3 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="MarShow" style="text-align:right">
                                    {{row.actual3| numFormat}}                                
                                </td>
                                <td :class="row.kelas"  v-if="MarShow" style="text-align:right">
                                    {{row.varian3 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="AprShow" style="text-align:right">
                                    {{row.budget4 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="AprShow" style="text-align:right">
                                    {{row.actual4| numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="AprShow" style="text-align:right">
                                    {{row.varian4 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="MeiShow" style="text-align:right">
                                    {{row.budget5 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="MeiShow" style="text-align:right">
                                    {{row.actual5 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="MeiShow" style="text-align:right">
                                    {{row.varian5 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="JunShow" style="text-align:right">
                                    {{row.budget6 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="JunShow" style="text-align:right">
                                    {{row.actual6| numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="JunShow" style="text-align:right">
                                    {{row.varian6 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="JulShow" style="text-align:right">
                                    {{row.budget7 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="JulShow" style="text-align:right">
                                    {{row.budget7 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="JulShow" style="text-align:right">
                                    {{row.budget7 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="AgtShow" style="text-align:right">
                                    {{row.budget8 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="AgtShow" style="text-align:right">
                                    {{row.actual8 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="AgtShow" style="text-align:right">
                                    {{row.varian8 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="SepShow" style="text-align:right">
                                    {{row.budget9 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="SepShow" style="text-align:right">
                                    {{row.actual9 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="SepShow" style="text-align:right">
                                    {{row.varian9 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="OktShow" style="text-align:right">
                                    {{row.budget10 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="OktShow" style="text-align:right">
                                    {{row.actual10 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="OktShow" style="text-align:right">
                                    {{row.varian10 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="NovShow" style="text-align:right">
                                    {{row.budget11 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="NovShow" style="text-align:right">
                                    {{row.actual11 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="NovShow" style="text-align:right">
                                    {{row.varian11 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="DesShow" style="text-align:right">
                                    {{row.budget12 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="DesShow" style="text-align:right">
                                    {{row.actual12 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="DesShow" style="text-align:right">
                                    {{row.varian12 | numFormat}}
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    {{row.budgetytd | numFormat}}
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    {{row.actualytd | numFormat}}
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    {{row.varianytd | numFormat}}>
                                </td>

                                <td :class="row.kelas" style="text-align:right">
                                    {{row.budget | numFormat}}
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    {{row.actual | numFormat}}                                
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    {{row.varian | numFormat}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import targetcollection from "../../apis/targetcollection";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {tabIndex:1,layout:'', departkd:'',tahun:moment(this.$store.state.user.tglaktif).format('YYYY')},
      model: {copysrc:0,markup:0,tahunsrc:parseInt(this.$store.state.user.tglaktif.substring(0,4))},
      lkuDeptShow:false,
      JanShow:true,
      FebShow:true,
      MarShow:true,
      AprShow:true,
      MeiShow:true,
      JunShow:true,
      JulShow:true,
      AgtShow:true,
      SepShow:true,
      OktShow:true,
      NovShow:true,
      DesShow:true,
      layouts:[],
      horizontal: true,
      isLoading: false,
      reportUrl: null,
      showReport:false,
      rptLines:[]
    };
  },
components: { Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
created: async function (){
     let bln = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').month();
     let awal= parseInt(this.$store.state.user.awalbln || '1')-1;
     if ((bln-awal) > 10) {
         this.enableNextYear=true;
     }
  },
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        this.filter.tahun=tgl1.format('YYYY');
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
                this.rptLines= await targetcollection.actual(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                this.reportUrl= await targetcollection.viewprint(this.filter);
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const response = await targetcollection.actualexport(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },

    close(){
      router.push("home");
    }
  }
};
</script>
